module.exports = __webpack_public_path__ + "img/Flag_of_Myanmar.b5dc0793.svg";